//导航条
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import dataList from "../util";

const Navigation = () => {
  const [chineseName, setChineCseName] = useState("首页");

  const location = useLocation(); // 获取当前路由信息

  useEffect(() => {
    dataList.forEach((e, index) => {
      if (location.pathname === e.path) {
        console.log(location.pathname, "==", e);
        setChineCseName(e.chineseName);
        return;
      }
    });
  }, [location]); // 监听location对象的变化

  return (
    <div>
      <h3 className="title">{chineseName}</h3>
    </div>
  );
};

export default Navigation;
